import { render, staticRenderFns } from "./CaseSection.vue?vue&type=template&id=2e82dbbf&scoped=true"
import script from "./CaseSection.vue?vue&type=script&lang=js"
export * from "./CaseSection.vue?vue&type=script&lang=js"
import style0 from "./CaseSection.vue?vue&type=style&index=0&id=2e82dbbf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e82dbbf",
  null
  
)

export default component.exports